import { render, staticRenderFns } from "./SelectDropdown.vue?vue&type=template&id=dc0d0648&scoped=true"
import script from "./SelectDropdown.vue?vue&type=script&lang=js"
export * from "./SelectDropdown.vue?vue&type=script&lang=js"
import style0 from "./SelectDropdown.vue?vue&type=style&index=0&id=dc0d0648&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc0d0648",
  null
  
)

export default component.exports